import styled from "styled-components";
import {MAIN_COLOR} from "../../globalThemes";
import {Link} from "react-router-dom";

export const ButtonHash = styled.p`
    color: orange;
    margin-top: 3px;
`;

export const StyledSpan = styled.span`
    font-weight: 300;    
`;

export const StyledButton = styled(Link)`
    cursor: pointer;
    outline: none;
    font-family: Roboto Condensed, serif;
    font-weight: bold;
    font-size: 14px;
    padding: 5px;
    color: ${({color}) => color ?? 'white'};
    border: 0;
    width: 240px;
    border-right: 2px ${MAIN_COLOR} solid;
    background-size: 200% 100%;
    background-image: linear-gradient(to left, ${MAIN_COLOR} 50%, ${({bg}) => bg} 50%);
    background-position: left bottom;
    transition: all 1s;
    text-align: left;
    line-height: 14px;
    height: 34px;
    text-decoration: none;
    
    &:before {
        content: "// ";
        color: ${MAIN_COLOR};
        letter-spacing: 2px;
    }
    
    &:hover {
        color: black;
        border-right: 2px white solid;
        background-position: right bottom;
        
        &:before {
            color: #2e302d;
        }
    }
    
    &:hover ${ButtonHash} {
        color: #222b1f;
    }
    
    @media screen and (orientation:portrait) {
        margin-left: 20px;
    }
`;
